import {
  ShaderStore,
  init_shaderStore
} from "./chunk-74QERPGX.mjs";
import {
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/ShadersWGSL/oitFinal.fragment.js
var name, shader, oitFinalPixelShaderWGSL;
var init_oitFinal_fragment = __esm({
  "node_modules/@babylonjs/core/ShadersWGSL/oitFinal.fragment.js"() {
    init_shaderStore();
    name = "oitFinalPixelShader";
    shader = `var uFrontColor: texture_2d<f32>;var uBackColor: texture_2d<f32>;@fragment
fn main(input: FragmentInputs)->FragmentOutputs {var fragCoord: vec2i=vec2i(fragmentInputs.position.xy);var frontColor: vec4f=textureLoad(uFrontColor,fragCoord,0);var backColor: vec4f=textureLoad(uBackColor,fragCoord,0);var alphaMultiplier: f32=1.0-frontColor.a;fragmentOutputs.color=vec4f(
frontColor.rgb+alphaMultiplier*backColor.rgb,
frontColor.a+backColor.a
);}
`;
    ShaderStore.ShadersStoreWGSL[name] = shader;
    oitFinalPixelShaderWGSL = { name, shader };
  }
});

export {
  oitFinalPixelShaderWGSL,
  init_oitFinal_fragment
};
